import React, { useEffect, useState } from 'react'
import s from './ShareDrawer.module.scss'
import { animated } from '@react-spring/web';
import { useDrag } from '@use-gesture/react';
import { useTypedSelector } from 'store/useTypedSelector';
import { useActions } from 'store/useActions';
import FriendsList from './FriendsList';
import MediaList from './MediaList';
import Actions from './Actions';

const ShareDrawer = ({ setIsShareOpened, api, openDrawer, y, isOpenShare, downloadLink }) => {
    const { isSlideChange } = useTypedSelector((state) => state.postSlice)
    const { setIsSlideChange } = useActions()
    const [isCopied, setIsCopied] = useState(false)

    const closeDrawer = () => {
        api.start({ y: window.innerHeight });
        setIsShareOpened(false);
        setIsSlideChange(true)
    };

    const bind = useDrag(
        ({ movement: [, my], direction: [, dy], last, velocity, cancel, event }) => {
            if (Math.abs(my) > 10) {
                event.stopPropagation();
            }

            if (last) {
                //@ts-ignore
                if (my > 100 || (dy > 0 && velocity > 0.5)) {
                    closeDrawer();
                }
            } else {
                api.start({ y: Math.max(0, my) });
            }
        },
        {
            from: () => [0, y.get()],
            bounds: { top: 0 },
            rubberband: true,
        }
    );

    useEffect(() => {
        if (isSlideChange) {
            closeDrawer()
        }
    }, [isOpenShare, isSlideChange])

    return (
        <div className={s.share_drawer}>
            <animated.div
                {...bind()}
                style={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    // height: '50vh',
                    background: 'rgba(255, 255, 255, 0.66)',
                    backdropFilter: 'blur(100px)',
                    transform: y.to((py) => `translateY(${py}px)`),
                    touchAction: 'none',
                    borderTopLeftRadius: '32px',
                    borderTopRightRadius: '32px',
                    boxShadow: '0 -2px 10px rgba(0,0,0,0.2)',
                }}
            >
                <div className={s.share_drawer_cont}>
                    <div style={{ width: '33px', height: '4px', background: "#F2F1F380", borderRadius: '2.5px' }} />
                </div>
                <div className={s.share_drawer_title}>
                    Share
                </div>
                {/* <div style={{ width: '100%', height: '1px', background: "#F2F1F30D", margin: '26px 0px' }} /> */}
                {/* <FriendsList /> */}
                <div style={{ width: '100%', height: '1px', background: "rgba(242, 241, 243, 0.2)", margin: '26px 0px' }} />
                <MediaList setIsCopied={setIsCopied} />
                <div style={{ width: '100%', height: '1px', background: "rgba(242, 241, 243, 0.2)", margin: '26px 0px' }} />
                <Actions isCopied={isCopied} downloadLink={downloadLink} />
            </animated.div>
        </div>
    )
}

export default ShareDrawer
